import { z } from 'zod';

/* Each attribute in the array represents a single option among many. For instance, an array of 3 items might have these names:
 * attribute[0].name: "vehicle_light.emergency.on"
 * attribute[1].name: "vehicle_light.emergency.off"
 * attribute[2].name: "vehicle_light.emergency.no_lights"
 * The attribute's token is used to create annotations.
 */

export const attributeZod = z.object({
  token: z.string(),
  name: z.string().transform((val) => {
    //REMARK: We are manually updated the taxonomy. This is a hack to meet our short-term needs.
    if (val === 'school_bus_stop_sign.flashing.yellow') {
      return 'school_bus_stop_sign.flashing_yellow';
    }
    if (val === 'school_bus_stop_sign.flashing.red') {
      return 'school_bus_stop_sign.flashing_red';
    }
    return val;
  }),
  tag: z.nullable(z.string()),
  description: z.nullable(z.string()),
  property: z.nullable(z.string()),
  isNegative: z.nullable(z.boolean()),
});

export const attributesRespZod = z.array(attributeZod);

export type AttributesResp = z.infer<typeof attributesRespZod>;
export type Attribute = z.infer<typeof attributeZod>;
